"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CartonLabelType = void 0;
exports.CartonLabelType = {
    CUSTOM: "CUSTOM",
    FBA_CONTENT: "FBA_CONTENT",
    FBA_SPD_SHIPPING: "FBA_SPD_SHIPPING",
};
//# sourceMappingURL=carton-label-type.js.map